import { useMemo } from "react";
import { get } from "lodash";
import { useSelector } from "react-redux";
import { isFunction } from "@cayuse/shared-react.utils.type-checks";

import Pager from "components/Pager";


export const pagingSelector = key => state => get(state, `${key}.content.paging`, {});

export const usePagination = (key, setPaging) => {
	if (!isFunction(setPaging)) {
		throw Error("A 'setPaging' callback must be provided to usePagination");
	}

	const { pageLimit, pageNumber } = useSelector(pagingSelector(key));

	const pageOffset = useMemo(() => Pager.pageOffsetByPageNumber(pageNumber), [ pageNumber ]);

	const setPageNumber = pageNumber => {
		setPaging({ pageNumber });
	};

	const setPageLimit = pageLimit => {
		setPaging({ pageLimit, pageNumber: 1 });
	};

	return {
		pageLimit,
		pageOffset,
		pageNumber,
		setPageLimit,
		setPageNumber
	};
};

export default usePagination;
